import script from "./NewProcessModal.vue?vue&type=script&setup=true&lang=js"
export * from "./NewProcessModal.vue?vue&type=script&setup=true&lang=js"

import "./NewProcessModal.vue?vue&type=style&index=0&id=972b091e&scoped=true&lang=css"

import exportComponent from "/builds/sense/sense-signer/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-972b091e"]])

export default __exports__